module.exports = __webpack_public_path__ + "img/switch-off.17f7401d.svg";